import { 
    Paper, 
    List, 
    ListItem, 
    ListItemText, 
    Typography, 
    Grid,
    Menu,
    MenuItem
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import DateRangeIcon from '@material-ui/icons/DateRange';
import CheckIcon from '@material-ui/icons/Check'
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';

import { styles } from './style';
import ListCost from '../listCost'
import Loading from '../loading';
import Snackbar from '../../components/snackbar';
import Header from '../../partials/header'
let id = -1;
function createData(isSystem, name, value) {
  return {isSystem, name, value };
} 
const rows = [createData(1, "electrict_cost", 0), createData(1, "water_cost", 0), createData(1, "internet_cost", 0), createData(1, "space_cost", 0), createData(1, "clean_cost", 0)];

class Cost extends Component {
    constructor(props) {
        super(props);
        this.state = {
            anchorEl: null,   
            rows: rows,
            month: new Date().getMonth() + 1,
            year: new Date().getFullYear(),
            years: [], 
            monthArray: [0,0,0,0,0,0,0,0,0,0,0,0] // =1 nếu tháng đó đã được lưu
        }
        this.monthArr = [1,2,3,4,5,6,7,8,9,10,11,12] // mảng các tháng trong năm
        this.stableCost = [] 
    } 
    years(){
        let startYr = 2018
        let arr = []
        for(let i = 0;i<= 10;i++){
            arr.push(i+startYr)
        } 
        return arr
    }
    handleSaveChange = async(payload) => {
        this.loading.startLoading() 
        if(payload.salaryEmployee)
        {
            let check = -1
            payload.rows.map((row,index)=> {
                if(row.name === 'employee_salary') check = index
            }) 
            if(check !== -1) { 
                payload.rows[check].value = payload.totalSalary
                payload.rows[check].detail =  payload.salaryEmployee
            }
            else
            payload.rows.push({
                "isSystem": 0,
                "name": "employee_salary",
                "value": payload.totalSalary,
                "detail":  payload.salaryEmployee
            }) 
        }
        let milisecond = new Date(this.state.year, this.state.month -1 , 1, 0, 0, 0, 0).getTime()
        let checkUpdate = await this.props.updateServiceCost({serviceCost: payload.rows, applyDate: milisecond}) 
        if(checkUpdate.code === 1)
        {
            this.mSnackbar.handleClick(this.props.t('service_table_cost_update_service_cost_successfully'))
            this.ListCost.changeState({'rows': Array.from(payload.rows), isAddNew: false, newCostName: '',newCostValue: '',month: this.state.month, year: this.state.year })
            // this.setState({serviceCost: true})
        } 
        else this.mSnackbar.handleClick(this.props.t('service_table_cost_update_service_cost_unsuccessfully')+' '+checkUpdate.message,'error')
        
        let checkGet = await this.props.getServiceCost(this.createMonthArray(this.state.year))  
        if(checkGet.code === 1 && checkGet.data.length)  this.checkMonthSaved(checkGet.data, this.state.year)
        this.loading.stopLoading() 
    } 
    componentDidMount = async () => {
        const _this = this 
        this.loading.startLoading()
        let check_stableCost = await this.props.getStableCost()   
        let years = await this.years()
        this.setState({years: years})
        if(check_stableCost.code === 1 && check_stableCost.data.length) _this.stableCost = check_stableCost.data[0].serviceCost
        else  _this.stableCost = rows
        this.fetchData(this.state.month,this.state.year)
        this.loading.stopLoading() 
    } 
    createMonthArray = (year) => {
        let monthArray = []
        for(let i = 1; i<= 12; i++)
        {
            let milisecond = new Date(year, i -1 , 1, 0, 0, 0, 0).getTime()
            monthArray.push(milisecond)
        }
        return monthArray
    } 
    handleClick = event => { 
        this.setState({ anchorEl: event.currentTarget });
    };  
    handleYear = (year) => {
        let {t} = this.props
        // if(!this.ListCost.checkEdit()) 
        // { 
            this.fetchData(this.state.month,  year)      
            this.setState({ anchorEl: null, year: year });
        // }
        // else  this.mSnackbar.handleClick(t('service_cost_you_dont_save_changes'))
    }
    handleMonth = (month) => {  
        let {t} = this.props 
        if(!this.ListCost.checkEdit()) 
        {
            let milisecond = new Date(this.state.year, month -1 , 1, 0, 0, 0, 0).getTime()  
            let rows = this.props.serviceCost.filter((ele)=> ele.applyDate === milisecond)  
            this.ListCost.changeState({'rows': rows.length ? Array.from(rows[0].serviceCost) :  Array.from(this.stableCost), month: month, year: this.state.year,  isAddNew: false, newCostName: '',newCostValue: '' }) 
            this.setState({  month: month });
        }
        else  this.mSnackbar.handleClick(t('service_cost_you_dont_save_changes'),'warning')
        // this.fetchData(month, this.state.year)
    }
    resetMonthState = (monthState) => {
        monthState.map((ele,index)=> monthState[index] = 0)
        return monthState
    }
    checkMonthSaved = (serviceCost, year) => {
        let monthArray = this.createMonthArray(year)  
        let monthState = this.state.monthArray
        monthState = this.resetMonthState(monthState)
        serviceCost.map((ele)=> {
            switch (ele.applyDate){
                case monthArray[0]: monthState[0] = 1; break;
                case monthArray[1]: monthState[1] = 1; break;
                case monthArray[2]: monthState[2] = 1; break;
                case monthArray[3]: monthState[3] = 1; break;
                case monthArray[4]: monthState[4] = 1; break;
                case monthArray[5]: monthState[5] = 1; break;
                case monthArray[6]: monthState[6] = 1; break;
                case monthArray[7]: monthState[7] = 1; break;
                case monthArray[8]: monthState[8] = 1; break;
                case monthArray[9]: monthState[9] = 1; break;
                case monthArray[10]: monthState[10] = 1; break;
                case monthArray[11]: monthState[11] = 1 ; break;
            }
        })
        this.setState({monthArray: monthState})
    }
    fetchData = async(month, year) => { 
        const _this = this 
        this.loading.startLoading()
        let milisecond = new Date(year, month -1 , 1, 0, 0, 0, 0).getTime() 
        let check = await this.props.getServiceCost(this.createMonthArray(year))
        this.loading.stopLoading()    
        if(check.code === 1 && check.data.length) {  
            this.checkMonthSaved(check.data, year) 
            let rows =  check.data.filter((ele) => ele.applyDate === milisecond)  
            this.ListCost.changeState({'rows': rows.length ? Array.from(rows[0].serviceCost) : Array.from(this.stableCost), month: month, year: year,  isAddNew: false, newCostName: '',newCostValue: '' }) 
        }
        else if(check.code === 1) { 
            this.checkMonthSaved(check.data, year) 
            this.ListCost.changeState({'rows': Array.from(this.stableCost), month: month, year: year,  isAddNew: false, newCostName: '',newCostValue: '' })
        }
        else  { 
            this.checkMonthSaved([], year) 
            this.mSnackbar.handleClick(check.message,'error')
        }

    }
    render() {  
        const { classes, t } = this.props;
        const {anchorEl} = this.state
        const open = Boolean(anchorEl); 
        let totalValue = 0
        this.state.rows.map((row, index) => totalValue += Number(row.value))   
        return (
        <div> 
            <Snackbar
                color='white'
                onRef={snackbar => (this.mSnackbar = snackbar)} 
            />  
            <Loading onRef={id => (this.loading = id)}/>
            <Header
                session= {t('sidebar_manage')}
                title= {t('sidebar_service_cost')} 
                // button= {t('service_cost_add_new')}
                // actionButton= {() => this.addNewCost(true)}
            />
            <Grid container spacing={24}>
                <Grid item xs={2} sm={2} className={classes.frameTitle}>
                    <Menu
                        id="long-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={()=>this.setState({anchorEl: null})}
                        PaperProps={{
                            style: {
                            maxHeight: 48 * 4.5,
                            width: 200,
                            },
                        }}
                    >
                        {this.state.years.map(year=> (
                            <MenuItem key={year} selected={year === this.state.year} onClick={()=>this.handleYear(year)}>
                            {year}
                            </MenuItem>
                        ))}
                    </Menu>
                    <Paper className={classes.root}>
                        <List
                            component="nav"
                            // subheader={<ListSubheader component="div">Nested List Items</ListSubheader>}
                            // className={classes.root}
                        >
                        <div className = {classes.titlePickDate}>
                            <Typography variant="h6" >{this.state.year}</Typography> 
                            <DateRangeIcon onClick={this.handleClick} style= {{cursor: 'pointer'}}/>  
                        </div>
                        {this.monthArr.map((month, index)=>
                            month === this.state.month ?
                            <ListItem button style={{backgroundColor: 'rgba(41, 47, 72, 0.25)'}} key={index}> 
                                <ListItemText primary={t('service_cost_month_'+ month)} />
                                {this.state.monthArray[index] ? <CheckIcon style={{color: '#2db253'}}/> : ''}
                            </ListItem>
                            :
                            <ListItem button onClick = {()=>this.handleMonth(month)} key={index}> 
                                <ListItemText primary={t('service_cost_month_'+ month)} />
                                {this.state.monthArray[index] ? <CheckIcon style={{color: '#2db253'}}/> : ''}
                            </ListItem>
                        )}                             
                        </List>
                    </Paper>
                </Grid>
                <Grid item xs={10} sm={10} className={classes.frameTitle}>
                    <ListCost title= {t('sidebar_service_cost')} onRef={id => (this.ListCost = id)} handleSaveChange = {this.handleSaveChange} tyleList = 'cost'/> 
                </Grid>
            </Grid>
            {/* <List onRef={id => (this.list = id)}/> */}
        </div>
        );
    }
}

Cost.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

const mapState = state => ({
    stableCost: state.stableCost.stableCost,
    serviceCost: state.serviceCost.serviceCost
});

const mapDispatch = dispatch => ({
    getServiceCost: dispatch.serviceCost.getServiceCost,
    updateServiceCost: dispatch.serviceCost.updateServiceCost,
    getStableCost: dispatch.stableCost.getStableCost
});

export default connect( mapState, mapDispatch)( translate("translations")(withStyles(styles, { withTheme: true })(Cost)));





// Khi tính chi phí mỗi tháng, thêm một dòng lương nhân viên , key là employee_salary, value là số lương cộng bonus, thêm detail là 1 array {mã nv,tên nv,lương nv,bonus}
// Kiem tra employee_salary trong bảng service_cost nếu có thì hien thi ,có thể câp nhật lại
// employee_salary co thể dc tính lại từ lương ở tháng hiện tại hoac tương lai
